import { useEffect, useState } from 'react';
import { getBalance } from '../../services/ExchangeService';
import WalletRow from './WalletRow';
import Toast from '../Toast';

/**
 * props:
 * - data
 * - isFuture
 * - onUpdate
 */
function Wallet(props) {

    const [balances, setBalances] = useState([]);
    const [fiat, setFiat] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [isFuture, setIsFuture] = useState(props.isFuture || false);
    const [notification, setNotification] = useState({ type: '', text: '' });

    function getBalanceCall() {
        getBalance(isFuture)
            .then((info) => {
                if (!info || typeof info !== 'object') {
                    setBalances([]);
                    setFiat('');
                    setIsLoading(false);
                    return;
                }

                const balances = Object.entries(info)
                    .filter(([, value]) => value && typeof value === 'object' && value.available !== undefined)
                    .map(([symbol, data]) => ({
                        symbol,
                        available: data.available,
                        onOrder: data.onOrder
                    }))
                    .filter(b => parseFloat(b.available) > 0 || parseFloat(b.onOrder) > 0 || parseFloat(b.available) < 0)
                    .sort((a, b) => {
                        if (a.symbol > b.symbol) return 1;
                        if (a.symbol < b.symbol) return -1;
                        return 0;
                    });

                if (props.onUpdate)
                    props.onUpdate(balances);

                setBalances(balances);
                setFiat(info.fiatEstimate);
                setIsLoading(false);
            })
            .catch(err => {
                const raw = err.response ? err.response.data : err.message;
                const text = typeof raw === 'string'
                    ? raw
                    : (raw && raw.msg) || (raw ? JSON.stringify(raw) : err.message);
                console.error(text);
                setNotification({ type: 'error', text });
                setIsLoading(false);
            })
    }

    useEffect(() => {
        setIsLoading(true);
        if (props.data && Array.isArray(props.data) && props.data.length) {
            setBalances(props.data.filter(b => b && b.symbol !== 'fiatEstimate'));
            const fiatRow = props.data.find(s => s.symbol === 'fiatEstimate');
            setFiat(fiatRow);
            setIsLoading(false);
        }
        else
            getBalanceCall();

    }, [props.data, isFuture])

    return (<>
        <div className="col-md-6 col-sm-12 mb-4">
            <div className="card border-0 shadow">
                <div className="card-header">
                    <div className="row">
                        <div className="col-7">
                            <h2 className="fs-5 fw-bold mb-0">Carteira</h2>
                        </div>
                        {
                            localStorage.getItem("hasFutures") === 'true'
                                ? (
                                    <div className='col-3'>
                                        <button className='btn btn-sm btn-secondary ms-2 me-2' onClick={() => setIsFuture(!isFuture)}>
                                            {
                                                isFuture
                                                    ? "Futuros"
                                                    : "Spot"
                                            }
                                        </button>
                                    </div>
                                )
                                : <></>
                        }
                        <div className="col-2">
                            <a href="/wallet" className="btn btn-sm btn-primary ms-2 me-2">
                                <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" /></svg>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="table-responsive divScroll">
                    <table className="table align-items-center table-flush table-sm table-hover tableFixHead">
                        <thead className="thead-light">
                            <tr>
                                <th className="border-bottom" scope="col">MOEDA</th>
                                <th className="border-bottom col-2" scope="col">DISPONÍVEL</th>
                                <th className="border-bottom col-2" scope="col">BLOQUEADO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                isLoading
                                    ? (
                                        <tr className='mb-3'>
                                            <td colSpan={3}>
                                                Carregando...
                                            </td>
                                        </tr>
                                    )
                                    : balances && balances.length
                                        ? balances.map(item => (
                                            <WalletRow key={`wallet${item.symbol}`} symbol={item.symbol} available={item.available} onOrder={item.onOrder} />
                                        ))
                                        : (
                                            <tr className='mb-3'>
                                                <td colSpan={3}>
                                                    Nenhum saldo encontrado.
                                                </td>
                                            </tr>
                                        )
                            }
                        </tbody>
                        <tfoot>
                            <tr className='mb-3'>
                                <td colSpan={3}>
                                    <b>Estimate:</b> {fiat}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <Toast type={notification.type} text={notification.text} />
    </>);
}

export default Wallet;
